import { render, staticRenderFns } from "./error-wrap.vue?vue&type=template&id=26e2d66e&scoped=true&"
import script from "./error-wrap.vue?vue&type=script&lang=js&"
export * from "./error-wrap.vue?vue&type=script&lang=js&"
import style0 from "./error-wrap.vue?vue&type=style&index=0&id=26e2d66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e2d66e",
  null
  
)

export default component.exports